import React from "react";

/**
 * 3-tier mastery dot for deck tiles.
 *   new      = ·  (muted)
 *   learning = ·  (amber)
 *   mastered = ·  (green)
 */
const LEVELS = {
  new: { label: "New", color: "bg-[color:var(--ink-faint)]", text: "text-[color:var(--ink-muted)]" },
  learning: { label: "Learning", color: "bg-amber-500", text: "text-amber-700" },
  mastered: { label: "Mastered", color: "bg-emerald-500", text: "text-emerald-700" },
};

export default function MasteryBadge({ level = "new", pct, compact = false, testId }) {
  const l = LEVELS[level] || LEVELS.new;
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${compact ? "text-[10px]" : "text-xs"} font-mono uppercase tracking-widest ${l.text}`}
      title={pct != null ? `${pct}% of cards mastered` : l.label}
      data-testid={testId || `mastery-${level}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${l.color}`} />
      {l.label}
    </span>
  );
}
